import React from 'react';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import { Refresh, WarningAmber } from '@mui/icons-material';
import type { AuditDynamicFormTableHeaderProps } from '../../types/auditFormTypes';

const AuditDynamicFormTableHeader: React.FC<AuditDynamicFormTableHeaderProps> = React.memo(({
  onRefreshSimulation,
  simulationLoading = false,
  simulationError = null,
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      fontWeight: 600,
      px: 0,
      py: 1,
      color: '#2C6CA0',
      gap: 0.25,
    }}
  >
    <Box sx={{ maxWidth: '140px', minWidth: '120px', flexBasis: '120px', textAlign: 'left', px: 0.5, ml: 3 }}>
      Name
    </Box>
    <Box sx={{ flexBasis: '140px', maxWidth: '140px', textAlign: 'left', px: 0.5, pl: 2 }}>
      Game-Pack
    </Box>
    <Box sx={{ flexBasis: '140px', maxWidth: '140px', textAlign: 'left', px: 0.5, pl: 2 }}>
      Range
    </Box>
    <Box sx={{ minWidth: 40, width: 40, maxWidth: 40, textAlign: 'right', px: 1, flex: '0 0 auto' }}>
      Sold
    </Box>
    <Box
      sx={{
        minWidth: 80,
        width: 80,
        maxWidth: 80,
        px: 1,
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        component="span"
        sx={{
          width: '100%',
          textAlign: 'center',
          whiteSpace: 'nowrap',
          lineHeight: 1,
        }}
      >
        Variance
      </Box>
    </Box>
    <Box
      sx={{
        minWidth: 36,
        width: 36,
        maxWidth: 36,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 1,
        flex: '0 0 auto',
        position: 'relative',
      }}
    >
      {onRefreshSimulation && (
        <Tooltip title={simulationLoading ? 'Refreshing variance…' : 'Refresh variance'} arrow>
          <span>
            <IconButton
              color="primary"
              onClick={onRefreshSimulation}
              disabled={simulationLoading}
              size="small"
              sx={{ p: 0.25 }}
            >
              {simulationLoading ? <CircularProgress size={18} /> : <Refresh sx={{ fontSize: 18 }} />}
            </IconButton>
          </span>
        </Tooltip>
      )}

      {simulationError && (
        <Box sx={{ position: 'absolute', right: 2, top: 2, lineHeight: 0 }}>
          <Tooltip title={`Variance preview error: ${simulationError}`} arrow>
            <WarningAmber sx={{ fontSize: 14, color: 'warning.main' }} />
          </Tooltip>
        </Box>
      )}
    </Box>
  </Box>
));

AuditDynamicFormTableHeader.displayName = 'AuditDynamicFormTableHeader';

export default AuditDynamicFormTableHeader;
